module.exports = __webpack_public_path__ + "img/Dantam Hair 31.cae5b01e.jpg";